import React from 'react';
// import { Link } from '';
// import { Link } from 'react-router-dom';
export const Footer = () => {
    let copyright = String.fromCodePoint(0x00A9);
  return (

    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col">
            <p className="text-center"> Abhishek Kumar Choudhary <br></br><span> {copyright} </span>Copyright 2024</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

// export default Footer;
